import { SLIDE_IMAGE_PATH } from 'src/components/common/BannerMtLink/constants'

export type BannerMtLinkSlide = {
  imgSrc: string
  title: string
  titleLines: string[]
}

function getTitleLines(title: string) {
  return title.split(/<br\s*\/?>/i).map(line => line.trim()).filter(line => line.length > 0)
}

export default function getBannerMtLinkSlides(options: {
  translate: (_key: string) => string
  staticSrc: string
  isMobile: boolean
}): BannerMtLinkSlide[] {
  const { translate, staticSrc, isMobile } = options
  const items = isMobile
    ? [
      {
        title: translate('Добавляйте в медкарту <br>заключения и анализы'),
        path: SLIDE_IMAGE_PATH.mobileDocs,
      },
      {
        title: translate('На приёме врач посмотрит <br>всё на компьютере'),
        path: SLIDE_IMAGE_PATH.mobileSeeDesktop,
      },
    ]
    : [
      {
        title: translate('Добавляйте в медкарту заключения <br>и анализы'),
        path: SLIDE_IMAGE_PATH.desktopDocsQr,
      },
      {
        title: translate('На приёме врач посмотрит всё <br>на компьютере'),
        path: SLIDE_IMAGE_PATH.desktopSeeDesktopQr,
      },
    ]

  return items.map(item => ({
    imgSrc: `${staticSrc}${item.path}`,
    title: item.title,
    titleLines: getTitleLines(item.title),
  }))
}
